<!-- 发布资讯 -->
<template>
  <div class="form-group-style">
    <h1 class="title">编辑百科</h1>
    <div class="formLine"></div>
    <el-row type="flex" justify="center" class="baike-container">
      <el-col :span="14">
        <el-form
          class="form-container"
          label-position="left"
          :model="info"
          :rules="infoRules"
          ref="userInfoForm"
        >
          <div class="form-item">
            <div class="form-input-item title1">
              <el-form-item prop="title">
                <el-input
                  placeholder="请输入百科标题"
                  class="input-control"
                  v-model="info.title"
                ></el-input>
              <span v-if="titleWords" class="word_error">{{titleWords}}</span>
              </el-form-item>
            </div>
          </div>
          <div class="form-item">
            <div class="form-input-item editor">
              <el-form-item prop="content">
                <UE :options="eidtorOptions" defaultMsg="" ref="ue" />
                <span v-if="contentWords" class="word_error">{{contentWords}}</span>
              </el-form-item>
            </div>
          </div>
          <div class="form-item label-cat">
            <div class="form-label">
              <span class="label">选择分类</span>
              <label class="warn">*</label>
            </div>
            <div class="form-input-item">
              <el-form-item prop="up_cat_id ">
                <el-select
                  v-model="info.up_cat_id"
                  placeholder="请选择一级分类"
                  @change="getChildren"
                  style="margin-right: 10px"
                >
                  <el-option
                    v-for="item in levelOneList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="cat_id">
                <el-select v-model="info.cat_id" placeholder="请选择二级分类">
                  <el-option
                    v-for="item in levelTwoList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">
              <span class="label">文章来源</span>
            </div>
            <div class="form-input-item">
              <el-form-item prop="source">
                <el-input
                  placeholder="请输入文章来源"
                  v-model="info.source"
                ></el-input>
                <span v-if="sourceWords" class="word_error">{{sourceWords}}</span>
              </el-form-item>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">
              <span class="label">封面图</span>
              <label class="warn">*</label>
            </div>
            <div class="form-input-item">
              <div
                class="upload-group clearfix"
                v-if="info.thumb && info.thumb !== ''"
              >
                <div class="upload-item">
                  <img :src="info.thumb_url" alt />
                  <div class="shadow">
                    <i class="el-icon-delete" @click="clearUpload(1)"></i>
                  </div>
                </div>
              </div>
              <el-form-item prop="thumb">
                <div
                  class="upload-group-1"
                  v-if="info.thumb == '' || !info.thumb"
                >
                  <i class="el-icon-plus"></i>
                  <input
                    type="file"
                    class="type-file"
                    accept="*"
                    @change="checkFile($event, 1)"
                    id="pictureUploadFile1"
                  />
                </div>
              </el-form-item>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">
              <span class="label">文章摘要</span>
            </div>
            <div class="form-input-item">
              <el-form-item prop="description">
                <el-input
                  type="textarea"
                  placeholder="选填，不填则自动选取文章的前200字，文章描述可帮助读者快速了解内容，将显示在文章列表页和分享页主体内容"
                  class="input-control"
                  v-model="info.description"
                ></el-input>
                <span v-if="desWords" class="word_error">{{desWords}}</span>
              </el-form-item>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">
              <span class="label">基础点击量</span>
            </div>
            <div class="form-input-item">
              <el-form-item prop="base_hits">
                <el-input
                  placeholder="请输入基础点击量"
                  v-model="info.base_hits"
                />
              </el-form-item>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">
              <span class="label">文章关键字</span>
              <label class="warn">*</label>
            </div>
            <div class="form-input-item">
              <el-form-item prop="keywords">
                <el-tag
                  v-model="newsTags"
                  v-for="(tag, index) in newsTags"
                  :key="index"
                  closable
                  :disable-transitions="false"
                  @close="handleCloseTag(tag)"
                  >{{ tag }}</el-tag
                >
                <template v-if="newsTags.length < 4">
                  <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    maxlength="6"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                  ></el-input>
                  <el-button
                    v-else
                    class="button-new-tag"
                    size="small"
                    @click="showInput"
                    >+ 添加关键字</el-button
                  >
                </template>
              </el-form-item>
            </div>
          </div>
          <div class="form-item">
            <div class="form-label">
              <span class="label">文章标签</span>
              <label class="warn">*</label>
            </div>
            <div class="form-input-item baikeLabel">
              <el-form-item prop="hasLabel">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="请输入标签/标签关键词"
                  placement="top"
                >
                  <el-select
                    v-model="labesVal"
                    multiple
                    filterable
                    remote
                    :multiple-limit="5"
                    :remote-method="searchLabels"
                    :loading="loading"
                    popper-class="baikeSelect"
                    placeholder="请输入标签/标签关键词"
                    no-data-text="没有找到对应的标签，请重新搜索或者新增标签"
                  >
                    <p class="selectTag">请选择1-5个标签</p>
                    <el-option
                      v-for="item in labesOption"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-tooltip>
              </el-form-item>
            </div>
            <el-button
              class="add-labels"
              @click="showAddLabel"
              style="margin-left: 20px"
              >新增标签</el-button
            >
          </div>
          <div class="form-button">
            <el-button type="primary" @click="submitForm('userInfoForm', 1)"
              >保存至草稿箱</el-button
            >
            <el-button type="primary" @click="submitForm('userInfoForm', 2)"
              >保存并发布</el-button
            >
            <el-button @click="$router.back()">返回</el-button>
          </div>
        </el-form>
      </el-col>
    </el-row>
    <!-- 新增标签 -->
    <add-label ref="addLabel" :callback="AddLabel"></add-label>
    <!-- 新增标签 -->
    <el-dialog
        title="违禁词提示"
        :visible.sync="wordsDialog"
        width="40%"
        :before-close="(done)=>{done()}">
        <div style="margin-bottom:10px;line-height: 20px;" v-if="findWords.type_common.length > 0">存在通用违禁词：<span style="color:red">{{findWords.type_common.join(',')}}</span></div>
        <div style="margin-bottom:10px;line-height: 20px;" v-if="findWords.type_risk.length > 0">存在风险违禁词：<span style="color:red">{{findWords.type_risk.join(',')}}</span></div>
        <div style="margin-bottom:10px;line-height: 20px;" v-if="findWords.type_high_risk.length > 0">存在高危违禁词：<span style="color:red">{{findWords.type_high_risk.join(',')}}</span></div>
        <div style="margin-bottom:10px;line-height: 20px;" v-if="findWords.type_author.length > 0">存在来源屏蔽词：<span style="color:red">{{findWords.type_author.join(',')}}</span></div>
        <div style="margin-bottom:10px;" v-if="findWords.type_risk.length > 0 && !findWords.type_high_risk.length > 0 && !findWords.type_common.length > 0 && !findWords.type_author.length > 0">风险违禁词在一定语义下可能会存在风险！</div>
        <div>请检查并修改后再进行保存！恶意填写违禁词，情节严重将进行账号冻结并追究责任。</div>
        <span slot="footer" class="dialog-footer">
            <template v-if="findWords.type_risk.length > 0 && !findWords.type_high_risk.length > 0 && !findWords.type_common.length > 0 && !findWords.type_author.length > 0">
                <el-button type="primary" @click="cancelSave">暂不保存</el-button>
                <el-button type="primary" @click="continueSave">继续保存</el-button>
            </template>
            <template v-else>
                <el-button type="primary" @click="cancelSave">确定</el-button>
            </template>
        </span>
    </el-dialog> 
  </div>
</template>
<script>
import UE from '@/components/editoritem/uEditor';
import AddLabel from "./addLabel.vue";
import { validateEmpty } from "@/utils/validate";
import { mapGetters } from "vuex";
import { validateBit } from "@/utils/validate";
import {getFilterWords} from '@/service/customer'
import {
  uploadFile,
  listMHgetWikipediaLabel,
  listCategoriesLevelOne,
  lisCategoriesLevelTwo,
  getWikipediaDetail,
  editWikipediaDetail,
} from "@/service/wikipedia";
import { UPLOAD_CODE } from "@/config/index";

export default {
  name: "addBaike",
  components: {
    UE,
    AddLabel,
  },
  data() {
    return {
      info: {},
      levelOneList: [],
      levelTwoList: [],
      newsTags: [],
      inputVisible: false,
      inputValue: "",

      cateName: "",
      categoryList: "",
      infoRules: {
        title: [
          { validator: validateEmpty, result: "文章标题", trigger: "blur" },
          { min: 1, max: 30, message: "长度1到30个字符" },
        ],
        up_cat_id: [
          {
            required: true,
            message: "请选择一级分类",
          },
        ],
        cat_id: [
          {
            required: true,
            message: "请选择二级分类",
          },
        ],
        thumb: [{ required: true, message: "请上传封面图" }],
        source: [{ min: 2, max: 15, message: "长度2到15个字符" }],
        base_hits: [
          {
            validator: validateBit,
            min: 0,
            max: 10000000,
            result: "基础点击量",
          },
        ],
        hasLabel: [
          { required: true, message: "请至少添加一个标签", trigger: "blur" },
        ],
        keywords: [
          {
            required: true,
            message: "请至少添加一个关键字",
            trigger: "change",
          },
        ],
        description: [
          { result: "摘要", trigger: "blur" },
          { max: 200, message: "长度0到200个字符" },
        ],
        content: [
          { validator: validateEmpty, result: "内容", trigger: "blur" },
          { min: 10, max: 12000, message: "长度10到12000个字符" }

        ],
      },
      isClear: false,
      htmlContent: "",
      loading: false,
      labesOption: [],
      labesVal: null,
      labelArr: [],
      // 编辑器配置
      eidtorOptions: {
          pictureConfig: {
          code: UPLOAD_CODE.wiki
          },
          videoConfig: {
          code: UPLOAD_CODE.wikiVideo
          },
          wordLimit:12000,
          config: {
          items : ['source', '|', 'undo', 'redo', '|', 'justifyleft', 'justifycenter', 'justifyright', '|', 'forecolor', 'bold', 'selectall', 'removeformat', 'clearhtml', 'quickformat', '|', 'picture', 'link', 'unlink', 'video', 'table', 'fullscreen','addIframe'],
          }
      },
      filterWords:{},
      findWords:{
          type_risk:[],
          type_common:[],
          type_high_risk:[],
          type_author:[]
      },
      arisenWords:[],
      wordsDialog:false,
    };
  },
  created(){
      getFilterWords().then(res => {
          this.filterWords = res
      })
  },
  computed: {
    ...mapGetters(["permission_siteId"]),
    titleWords(){
        let words = []
        if(this.arisenWords && this.arisenWords.length>0){
            this.arisenWords.forEach((item)=>{
                if(this.info.title && this.info.title.indexOf(item) != -1){
                    words.push(item)
                }
            })
        }
        return words.length > 0 ? words.join(',') : null
    },
    sourceWords(){
      let words = []
      if(this.arisenWords && this.arisenWords.length>0){
          this.arisenWords.forEach((item)=>{
              if(this.info.source && this.info.source.indexOf(item) != -1){
                  words.push(item)
              }
          })
      }
      return words.length > 0 ? words.join(',') : null
    },
    contentWords(){
      let words = []
      if(this.arisenWords && this.arisenWords.length>0){
          this.arisenWords.forEach((item)=>{
              if(this.info.content && this.info.content.indexOf(item) != -1){
                  words.push(item)
              }
          })
      }
      return words.length > 0 ? words.join(',') : null
    },
    desWords(){
      let words = []
      if(this.arisenWords && this.arisenWords.length>0){
          this.arisenWords.forEach((item)=>{
              if(this.info.description && this.info.description.indexOf(item) != -1){
                  words.push(item)
              }
          })
      }
      return words.length > 0 ? words.join(',') : null
    }
  },
  watch: {
    labesVal() {
      this.$set(
        this.info,
        "hasLabel",
        this.labesVal.length <= 0 ? "" : "hasLabel"
      );
    },
  },
  mounted() {
    this.initData();
  },

  methods: {
    sleep(time) {
      return new Promise((resolve) => setTimeout(resolve, time));
    },
    async initData() {
      this.id = this.$route.query.id;
      await getWikipediaDetail(this.id).then((data) => {
        this.info = data;
        this.$refs.ue.pushContent(data.content)
        this.newsTags = data.keywords;
        this.labesOption = data.tags;
        data.tags.forEach((el) => {
          this.labesVal.push(el.id);
        });
      });
      await listCategoriesLevelOne().then((data) => {
        this.levelOneList = data;
        lisCategoriesLevelTwo(this.info.up_cat_id).then((data) => {
          this.levelTwoList = data.sub_category;
        });
      });
    },
    AddLabel() {
      //console.log('标签新增成功！')
    },
    showAddLabel() {
      this.$refs.addLabel && this.$refs.addLabel.open();
    },
    getChildren(val) {
      //查询二级分类
      this.info.cat_id = "";
      this.levelTwoList = [];
      lisCategoriesLevelTwo(val).then((data) => {
        this.levelTwoList = data.sub_category;
      });
    },
    //关键字
    handleCloseTag(tag) {
      this.newsTags.splice(this.newsTags.indexOf(tag), 1);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.newsTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    searchLabels(query) {
      //查询标签
      if (query !== "") {
        this.loading = true;
        let conditions = {};
        if (!!query) {
          conditions.name = query;
        }
        let that = this;
        setTimeout(() => {
          listMHgetWikipediaLabel(conditions)
            .then((response) => {
              that.loading = false;
              that.labesOption = response;
            })
            .catch((err) => {
              console.log(err);
              that.loading = false;
            });
        }, 200);
      }
    },
    submitLabels() {
      //提交新增标签
      this.showError = false;
      var labelArr = this.addTextarea.split(/[(\r\n)\r\n]+/);
      labelArr.forEach((el) => {
        if (el.length > 6) {
          this.errorCnt = "'" + el + "'超长，请修改";
          this.showError = true;
          return null;
        }
      });
      const index = labelArr.findIndex((v, v1) => {
        const k = labelArr.findIndex((a, a1) => {
          return a === v && a1 !== v1;
        });
        return k >= 0;
      });
      if (index >= 0) {
        this.errorCnt = "不能添加重复的标签，请修改";
        this.showError = true;
        return null;
      }
      if (this.showError) {
        return null;
      } else {
        this.labelArr = labelArr;
        this.reset();
      }
    },
    handleClose() {
      this.reset();
    },
    reset() {
      this.errorCnt = null;
      this.showError = false;
      this.addVisible = false;
      this.addTextarea = null;
    },
    // 清空上传
    clearUpload() {
      this.$set(this.info, "thumb", "");
      this.$set(this.info, "thumb_url", null);
      document.querySelector("#pictureUploadFile").value = "";
    },
    // 文件上传
    checkFile(e) {
      const file = e.target;
      const filePath = file.value;
      if (!filePath) return false;
      // 验证格式是否匹配
     if(!/.(jpg|jpeg|png|webp)$/.test(filePath)){
        this.$message({
            type: 'error',
            message: '请选择JPG/PNG/JPEG/WEBP格式的图片'
        })
        return false
      }
      // 验证上传文件大小
      const fileSize = file.files[0].size;
      if (fileSize / 1024 / 1024 > 2) {
        this.$message({
          type: "error",
          message: "上传的图片不能大于2M",
        });
        return false;
      }
      this.upload(file.files[0]);

    },
    // 上传封面图片
    async upload(file) {
      try {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("code", "wikipedia");
        formData.append("site_id", this.permission_siteId);
        const res = await uploadFile("wikipedia", formData);
        this.$set(this.info, "thumb", res.path);
        this.$set(
          this.info,
          "thumb_url",
          "https://" + res.full_url + "!watermark"
        );
      } catch (error) {
        this.$message({
          type: "error",
          message: error.message || "上传封面图片错误",
        });
      }
    },
    submitForm(formName, type) {
      if(type == 2 ){
        this.info.is_publish = 1
      }
      this.info.status = type;
      this.info.keywords = this.newsTags.join(",");
      this.info.tag_ids = this.labesVal.join(",");
      this.info.content = this.$refs.ue.getContent().html;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.info.base_hits != "") {
            this.info.base_hits = parseInt(this.info.base_hits);
          }
          let isPass = this.validFilterWords(this.info)
          if(type == 2 && !isPass){
            this.wordsDialog = true;
          }else{
            this.editWikipediaDetail(this.info,type)
          }

        }
      });
    },
    editWikipediaDetail(info,type){
      editWikipediaDetail(this.id, info)
      .then(() => {
        this.sleep(1000).then(() => {
          if (type == 1) {
            this.$confirm("已成功保存至草稿箱！", "提示", {
              confirmButtonText: "完成",
              cancelButtonText: "继续编辑",
              type: "success",
            })
              .then(() => {
                  this.$router.push({ path: "drafts" });
              })
              .catch(() => {
                console.log("继续编辑");
              });
          } else {
            this.$message({
              type: "success",
              message: "编辑成功",
            });
            this.$router.push({ path: "index" });
          }
        });
      })
      .catch((err) => {
        this.$message({
          type: "error",
          message: err.message || "编辑失败",
        });
      });
    },
    // 继续保存
    continueSave(){
        this.addWikipedia(this.info,2)
        this.wordsDialog = false
    },
    // 暂不保存
    cancelSave(){
        this.arisenWords = [];
        if(this.findWords){
            for(let key in this.findWords){
                if(this.findWords[key] && this.findWords[key].length>0){
                    this.arisenWords.push(...this.findWords[key])
                }
            }
        }
        this.arisenWords = Array.from(new Set(this.arisenWords))
        this.wordsDialog = false
    },
    validFilterWords(info){
        this.findWords = {
            type_risk:[],
            type_common:[],
            type_high_risk:[],
            type_author:[]
        },
        // 风险违禁词
        this.filterWords.type_risk.forEach((item,index) => {
            if(info.title.indexOf(item) != -1){
                this.findWords.type_risk.push(item)
            }else if(info.source.indexOf(item) != -1){
              this.findWords.type_risk.push(item)
            }else if(info.content.indexOf(item) != -1){
              this.findWords.type_risk.push(item)
            }else if(info.description.indexOf(item) != -1){
              this.findWords.type_risk.push(item)
            }
            this.findWords.type_risk = Array.from(new Set(this.findWords.type_risk))
        });
        // 通用违禁词
        this.filterWords.type_common.forEach((item,index) => {
            if(info.title.indexOf(item) != -1){
                this.findWords.type_common.push(item)
            }else if(info.source.indexOf(item) != -1){
              this.findWords.type_common.push(item)
            }else if(info.content.indexOf(item) != -1){
                this.findWords.type_common.push(item)
            }else if(info.description.indexOf(item) != -1){
              this.findWords.type_common.push(item)
            }
            this.findWords.type_common = Array.from(new Set(this.findWords.type_common))

        });
        // 高危违禁词
        this.filterWords.type_high_risk.forEach((item,index) => {
            if(info.title.indexOf(item) != -1){
                this.findWords.type_high_risk.push(item)
            }else if(info.source.indexOf(item) != -1){
                this.findWords.type_high_risk.push(item)
            }else if(info.content.indexOf(item) != -1){
                this.findWords.type_high_risk.push(item)
            }else if(info.description.indexOf(item) != -1){
              this.findWords.type_high_risk.push(item)
            }
            this.findWords.type_high_risk = Array.from(new Set(this.findWords.type_high_risk))

        });
        // 来源违禁词
        this.filterWords.type_author.forEach((item,index) => {
            if(info.source.indexOf(item) != -1){
                this.findWords.type_author.push(item)
            }
            this.findWords.type_author = Array.from(new Set(this.findWords.type_author))

        });
        if(this.findWords.type_risk.length > 0 
          || this.findWords.type_common.length > 0 
          || this.findWords.type_high_risk.length > 0
          || this.findWords.type_author.length > 0){
            return false
        }else{
            return true
        }
    },
  },
};
</script>

<style lang="less">
.el-form--label-top .el-form-item__label {
  padding: 10px 0 0;
}
.baike-container {
  background-color: #fff;
}
.baike-container .form-container .form-item .form-label {
  width: 100px !important;
}
.baike-container .form-container .form-input-item.title1,
.baike-container .form-container .form-input-item.editor {
  width: 100% !important;
}
.label-cat .form-input-item .el-form-item {
  width: 30%;
  float: left;
  margin-right: 10px;
}
.baike-container .form-container .form-input-item {
  width: 85% !important;
}
.baike-container .form-container .form-input-item.baikeLabel {
  width: 70% !important;
  float: left;
}
.baike-container .form-container .form-input-item.baikeLabel .el-select {
  width: 100%;
}
.baike-container .form-button {
  padding: 80px 0;
  padding-left: 30%;
}
.upload-group-1 {
  position: relative;
  width: 150px;
  height: 150px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  .el-icon-plus {
    font-size: 30px;
    color: #999;
  }
  .type-file {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100% !important;
    opacity: 0;
    cursor: pointer;
  }
}
.upload-group {
  //   padding-left: 15%;
  .upload-item {
    width: 150px;
    height: 150px;
    position: relative;
    float: left;
    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
    }
    .shadow {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      display: -webkit-box;
      -webkit-box-align: center;
      -webkit-box-pack: center;
      cursor: pointer;
      transition: all 0.1s linear;
      opacity: 0;
      .el-icon-delete {
        font-size: 21px;
        color: #fff;
        display: block;
      }
    }
    &:hover {
      .shadow {
        opacity: 1;
      }
    }
    .el-icon-close {
      position: absolute;
    }
  }
}
.house-door-uploadPicture {
  width: 500px !important;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.input-new-tag input {
  height: 30px !important;
}
.el-tag .el-icon-close {
  display: inline-block !important;
  border-radius: 50%;
  text-align: center;
  position: relative !important;
  cursor: pointer;
  font-size: 12px !important;
  height: 16px !important;
  width: 16px !important;
  line-height: 16px !important;
  vertical-align: middle;
  top: -1px !important;
  right: -5px !important;
}

.upload-group {
  padding-left: 0;
}
.baikeSelect .el-select-dropdown__item {
  display: inline !important;
  padding: 5px 10px !important;
}
.el-dialog__body {
  padding: 10px 20px 10px !important;
}
.el-dialog__body p {
  line-height: 30px;
}
.error-tip {
  color: red;
}
.selectTag {
  padding: 10px;
  font-size: 14px;
  color: #999;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  display: none;
}
.baikeSelect .el-select-dropdown__list {
  padding: 6px 10px;
  max-height: 210px !important;
  width: 800px;
}
.word_error{
    position: relative;
    top:-10px;
    color:red;
}
</style>